import React from 'react';
import PropTypes from 'prop-types';
import { Box, TextField } from '@material-ui/core';

import { useForm } from 'react-hook-form';

import TabPanel from 'components/TabPanel';

import MenuControls from './MenuControls';

const TitleTab = ({ onSubmit, handleClose, value, title, description }) => {
  const { handleSubmit, register } = useForm({
    defaultValues: {
      title,
      description
    }
  });

  return (
    <TabPanel value={value} index={0} style={{ minWidth: '700px' }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box p={2}>
          <h3>Widget Title</h3>
          <TextField
            inputRef={register}
            name="title"
            label="Type here..."
            variant="outlined"
            fullWidth
          />

          <h3>Widget Description</h3>
          <TextField
            inputRef={register}
            name="description"
            label="Type here..."
            variant="outlined"
            rows={7}
            multiline
            fullWidth
          />
        </Box>
        <MenuControls handleClose={handleClose} />
      </form>
    </TabPanel>
  );
};

TitleTab.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  title: PropTypes.string,
  description: PropTypes.string
};

TitleTab.defaultProps = {
  title: '',
  description: ''
};

export default TitleTab;
